class subscriptionKlaviyo extends HTMLElement {
  connectedCallback() {
    this.formElement.addEventListener('submit', this.onFormSubmitted.bind(this));
  }

  get idKlaviyo() {
    return this.getAttribute('data-id');
  }

  get formElement() {
    return this.querySelector('form');
  }

  get emailInput() {
    return this.formElement.querySelector('input[name="email"]');
  }

  get phoneInput() {
    return this.formElement.querySelector('input[name="phone"]');
  }

  get elementSubmit() {
    return this.formElement.querySelector('.article__newsletter-submit');
  }

  get ElementSms() {
    return document.querySelectorAll('.text-sms');
  }

  get ElementNews() {
    return document.querySelectorAll('.text-news');
  }

  get ElementSuccess() {
    return document.querySelectorAll('.text-success');
  }

  get ElementPhone() {
    return this.querySelector('phone-number');
  }

  get isSmsOptin() {
    if (this.ElementPhone.classList.contains('hide')) {
      return false
    } else {
      return true
    }
  }

  get phoneError() {
    return document.getElementById(this.ElementPhone.getAttribute('data-error'));
  }

  get textOpacity() {
    return document.getElementById(this.ElementPhone.getAttribute('data-opacity'));
  }

  async onFormSubmitted(event) {
    event.preventDefault();

    let formData = new FormData(this.formElement);
    let email = formData.get('email')?.trim();
    let phone = formData.get('phone')?.trim();


    let isUK = window.shop?.storeCountryConfig === 'uk';
    let sourceNews = isUK ? 'Pop in -20%' : 'Pop in -10%';
    let eventParamNews = isUK ? 'push-20' : 'push-10';
    let sourceSms = 'Pop in SMS';
    let eventParamSms = 'popin-sms';
    let listId = this.isSmsOptin ? this.phoneInput.dataset.list : this.emailInput.dataset.list;
    let source = this.isSmsOptin ? sourceSms : sourceNews;
    let trackMessage = this.isSmsOptin ? 'Signed Up from Pop in SMS' : `Signed Up from ${source}`;
    let eventType = this.isSmsOptin ? 'inscriptionSms' : 'inscriptionNL';
    let eventParam = this.isSmsOptin ? eventParamSms : eventParamNews;

    let profileAttributes = {
      email: email
    };

    if (this.isSmsOptin) {
      let iti = window.intlTelInputGlobals.getInstance(this.ElementPhone.querySelector('input'));
      if (!iti.isValidNumber()) {
        this.phoneError.classList.remove('error-hidden');
        this.textOpacity.classList.add('error-opacity');
        let that = this
        setTimeout(function () {
          that.phoneError.classList.add('error-hidden');
          that.textOpacity.classList.remove('error-opacity');
        }, 3000);
        return;
      } else {
        this.phoneError.classList.add('error-hidden');
        this.textOpacity.classList.remove('error-opacity');
      }
    }

    if (this.isSmsOptin) {
      profileAttributes.phone_number = phone;
      profileAttributes.subscriptions = {
        sms: {
          marketing: { consent: "SUBSCRIBED" },
          transactional: { consent: "SUBSCRIBED" },
        },
        whatsapp: {
          marketing: { consent: "SUBSCRIBED" },
          transactional: { consent: "SUBSCRIBED" },
        },
      };
    } else {
      profileAttributes.subscriptions = {
        email: {
          marketing: { consent: "SUBSCRIBED" },
        },
      };
    }

    let body = {
      data: {
        type: "subscription",
        attributes: {
          profile: {
            data: {
              type: "profile",
              attributes: profileAttributes,
            },
          },
          custom_source: source
        },
        relationships: {
          list: { data: { type: "list", id: listId } },
        },
      },
    };

    let options = {
      method: 'POST',
      headers: {
        accept: 'application/vnd.api+json',
        revision: '2025-10-15',
        'content-type': 'application/vnd.api+json',
      },
      body: JSON.stringify(body),
    };

    try {
      const response = await fetch(`https://a.klaviyo.com/client/subscriptions?company_id=${this.idKlaviyo}`, options);
      const status = response.status;
      if (status === 202) {
        if (this.isSmsOptin) {
          this.ElementSms.forEach(function (item) {
            item.classList.add('hide');
          });
          this.ElementSuccess.forEach(function (item) {
            item.classList.remove('hide');
          });
          this.elementSubmit.classList.add('hide');
        } else {
          this.ElementNews.forEach(function (item) {
            item.classList.add('hide');
          });
          this.ElementSms.forEach(function (item) {
            item.classList.remove('hide');
          });
        }
        this.trackEvent(eventType, eventParam, email, trackMessage);

      }
    } catch (e) { }
  }

  trackEvent(type, parameter, email, message) {
    // GTM
    if (window.shop.gtmV2Active) {
      window.dataLayer.push({
        event: type,
        event_parameter: parameter,
      });
    } else {
      console.log('dataLayer', { type, parameter });
    }

    // Klaviyo
    Klaviyo.push(['identify', {
      $email: email
    }]);
    Klaviyo.push(['track', message]);
  }


}

try {
  window.customElements.define('subscription-klaviyo', subscriptionKlaviyo);
} catch (e) { }